module.exports = __webpack_public_path__ + "static/media/stir-splash-photo-desktop.4b40f87a.jpg";